<template>
    <div class="ui-row">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
    .ui-row {
        margin-bottom: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/row/page.vue